import { MARKET_LABEL, pct } from "./valueFormat";

const signed = (v) => `${v >= 0 ? "+" : ""}${v.toFixed(2)}u`;

const tone = (v) => (v == null || v === 0 ? "" : v > 0 ? "is-up" : "is-down");

export function MarketBreakdown({ rows }) {
  if (!rows?.length) return null;
  return (
    <div className="vs-markets" data-testid="value-markets">
      <div className="vs-mrow vs-mhead"><span>Market</span><span>Picks</span><span>Record</span><span>Hit rate</span><span>Profit</span><span>ROI</span><span>Avg EV</span></div>
      {rows.map((m) => (
        <div key={m.market} className="vs-mrow" data-testid={`value-market-${m.market}`}>
          <b>{MARKET_LABEL[m.market] || m.market}</b>
          <span>{m.total}</span>
          <span>{m.wins}-{m.losses}{m.pushes ? `-${m.pushes}` : ""}</span>
          <span data-testid={`value-market-hit-${m.market}`}>{pct(m.hit_rate)}</span>
          <span className={m.settled ? tone(m.profit) : ""} data-testid={`value-market-profit-${m.market}`}>{m.settled ? signed(m.profit) : "—"}</span>
          <span className={tone(m.roi)}>{m.roi == null ? "—" : `${(m.roi * 100).toFixed(1)}%`}</span>
          <span>{m.avg_ev == null ? "—" : `+${(m.avg_ev * 100).toFixed(1)}%`}</span>
        </div>
      ))}
    </div>
  );
}
